const TRAINING_VEHICLES = [
  "Ô tô con tập lái",
  "Ô tô tải tập lái",
  "Bơm bê tông",
];

export const applyTrainingVehiclePrice = (price, vehicleType, discount = 0) => {
  if (!price) return price;

  if (TRAINING_VEHICLES.includes(vehicleType)) {
    return Math.round(price * 1.2);
  }

  return price;
};